<ng-container *ngIf="navNodes$ | async as navNodes">
  <ng-container *ngIf="navNodes.size > 0">
    <div class="ds-grid container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="list-group">
            <ng-container
              *ngFor="let navLinksNodesKeyVal of navigationComponentService.mapToArray(navNodes)">
              <ng-container *ngFor="let navLink$ of navLinksNodesKeyVal">
                <ng-container *ngIf="navLink$ | async as navLink">
                  <cx-generic-link
                    [class]="'list-group-item list-group-item-action btn dropdown-mobile--spacer ds-cursor--pointer border-none mb-1'"
                    [target]="navLink.target" [url]="navLink.url">
                    <span>{{navLink.linkName}}</span>
                  </cx-generic-link>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
